import { sortByAtomicNumber } from "../organizations";
import type { Nullable } from "../types";
import {
	getServiceCalculationItemAtomicNumber,
	type SortableServiceCalculationItem,
} from "./get-service-calculation-item-atomic-number";

/**
 * This function sorts the service calculation items by their atomic number.
 * @param _items
 * @returns
 */
export function sortServiceCalculationItems<T extends SortableServiceCalculationItem>(
	_items: Nullable<T[]>,
): T[] {
	if (!_items) return [];
	const items = [..._items];
	const withAtomicNumber = items.map((item) => ({
		item,
		fullNumber: getServiceCalculationItemAtomicNumber(items, item),
	}));
	withAtomicNumber.sort((a, b) => {
		return sortByAtomicNumber(a, b);
	});
	return withAtomicNumber.map((item) => item.item);
}
